import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from './Roundel.module.scss'

export const XRoundelIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 32,
  height = 32,
  className,
  ...rest
}) => {
  return (
    <Icon
      className={classnames(styles.x, className)}
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <path
        d="M17.5464 14.882L23.5921 8H22.16L16.9083 13.9743L12.7169 8H7.88135L14.221 17.035L7.88135 24.251H9.31349L14.8559 17.9405L19.2833 24.251H24.1188M9.83038 9.0576H12.0306L22.1589 23.2453H19.9582"
        data-testid="roundel-icon-x"
        fill="#ffffff"
        className={styles.white}
      />
    </Icon>
  )
}
